import { type ImageResource } from "@src/images/Images";

const insertResolution = (path: string, resolution: string): string => {
    return path.replace(".", `@${resolution}.`);
};

export const webSource = (image: ImageResource, resolution: string): string => {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    return require(`../assets/images/${insertResolution(image.path, resolution)}`);
};
